var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { fileToBase64 } from '@isyc-react/archives';
import { useNotificationHubContext } from '@isyc-react/form/modules/context';
import { useArchiveCreateFrontAndBackListInternalMutationPromise, useArchiveCreateInternalMutationPromise, useDocumentalRequestResolveMutationPromise, } from '@isyc-react/oc-api';
import { awaitableApollo } from '@isyc-react/oc-api/apollo';
import { ArchiveReceptionChannel } from '@isyc-react/types';
import { NotificationItemType } from '@isyc-react/form/modules/base';
import { nanoid } from 'nanoid';
import { DocumentTypeFormat } from 'common-app/override/types';
export var DocumentalRequestErrorCode;
(function (DocumentalRequestErrorCode) {
    DocumentalRequestErrorCode["GET_GENERIC"] = "GET_GENERIC";
    DocumentalRequestErrorCode["NO_OPTION_SELECTED"] = "NO_OPTION_SELECTED";
    DocumentalRequestErrorCode["NO_ACCEPTED_FILE"] = "NO_ACCEPTED_FILE";
    DocumentalRequestErrorCode["REJECTED_FILE"] = "REJECTED_FILE";
    DocumentalRequestErrorCode["LOW_FILE_QUALITY"] = "LOW_IMAGE_QUALITY";
    DocumentalRequestErrorCode["DOCUMENT_EDM_ERROR"] = "DOCUMENT_EDM_ERROR";
    DocumentalRequestErrorCode["UPLOADING_ERROR"] = "UPLOADING_ERROR";
})(DocumentalRequestErrorCode || (DocumentalRequestErrorCode = {}));
export const useUploadDocuments = (props) => {
    const { docToUpload, postFn } = props, rest = __rest(props, ["docToUpload", "postFn"]);
    docToUpload.forEach(d => useUpload(Object.assign({ docReq: d }, rest)));
    //TODO: Revisar si pueden pasar de estado el dossier
};
const useUpload = (props) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const { docReq, businessUnitId, onSuccess } = props;
    const { doc, request, relatedId, relatedObjectTypeId } = docReq;
    const { file, front, back, selectedFormat } = doc;
    const archiveCreateFB = useArchiveCreateFrontAndBackListInternalMutationPromise();
    const archiveCreateF = useArchiveCreateInternalMutationPromise();
    const documentationRequestResolve = useDocumentalRequestResolveMutationPromise();
    const { addNotifications } = useNotificationHubContext();
    if ((selectedFormat === DocumentTypeFormat.SINGLE && file) ||
        (selectedFormat === DocumentTypeFormat.FRONT_BACK && back && front)) {
        const uploadFileError = () => { var _a; return useUploadError((_a = file === null || file === void 0 ? void 0 : file.name) !== null && _a !== void 0 ? _a : `${front === null || front === void 0 ? void 0 : front.name} - ${back === null || back === void 0 ? void 0 : back.name}`); };
        const documentalId = doc.selected && request.tId === 0 ? doc.selected : request.tId;
        let archive = undefined;
        if (selectedFormat === DocumentTypeFormat.SINGLE && file) {
            const query = { receptionChannelType: ArchiveReceptionChannel.WEB_PORTAL };
            const base64 = yield fileToBase64(file);
            query.content = base64;
            query.name = file.name;
            const response = yield awaitableApollo(archiveCreateF({
                businessUnitId,
                archiveCreateInternal: Object.assign({ relatedObjectTypeId,
                    relatedId, typologyTemplateIdList: [documentalId] }, query),
            }));
            if (response.error || response.errors || !response.data) {
                uploadFileError();
                return;
            }
            archive = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.archive_createInternal;
        }
        if (selectedFormat === DocumentTypeFormat.FRONT_BACK && back && front) {
            const query = {
                receptionChannelType: ArchiveReceptionChannel.WEB_PORTAL,
            };
            const base64Front = yield fileToBase64(front);
            const base64Back = yield fileToBase64(back);
            query.contentFront = base64Front;
            query.nameFront = front.name;
            query.contentBack = base64Back;
            query.nameBack = back.name;
            const response = yield awaitableApollo(archiveCreateFB({
                businessUnitId,
                archiveCreateFrontAndBackListInternal: [
                    Object.assign({ relatedObjectTypeId,
                        relatedId, typologyTemplateIdList: [documentalId] }, query),
                ],
            }));
            if (response.error || response.errors || !response.data) {
                uploadFileError();
                return;
            }
            archive = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.archive_createFrontAndBackListInternal[0];
        }
        if (request.docReqId && (archive === null || archive === void 0 ? void 0 : archive.id)) {
            const resolved = yield awaitableApollo(documentationRequestResolve({
                documentRequestId: request.docReqId,
            }));
            if (resolved.error || resolved.errors || !resolved.data) {
                uploadFileError();
                return;
            }
        }
        addNotifications([
            {
                type: NotificationItemType.SUCCESS,
                key: nanoid(),
                message: `Succès du téléchargement du fichier`,
                life: 5000,
            },
        ]);
        onSuccess && onSuccess(documentalId);
        onSuccess && ((_c = request.options) === null || _c === void 0 ? void 0 : _c.forEach(o => onSuccess(o.id)));
    }
});
export const useUploadError = (fileName) => {
    const { addNotifications } = useNotificationHubContext();
    console.error('[Upload Error]');
    addNotifications([
        {
            type: NotificationItemType.ERROR,
            key: nanoid(),
            message: `Erreur lors du téléchargement du fichier ${fileName}`,
            life: 5000,
        },
    ]);
    //TODO: Gestionar errores
    //const errors = documentalError([], [DocumentalRequestErrorCode.UPLOADING_ERROR])
    //setState(state => ({ ...state, uploading: false, errors }))
};
